<template>
    <router-view></router-view>
</template>

<script>
import '../../html/components/crumbs/crumbs.scss';
import '../../html/components/banner/banner.scss';
export default {};
</script>

<style>
</style>
